import { WRENCH_MODE_EVENTS_CRUD_ACTION_CREATORS } from '../actions/wrench_mode_events_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';

export const wrenchModeEventsRestCrudThunksForSupplier = new RestCrudThunks(
	'events',
	'event',
	'event',
	'events',
	WRENCH_MODE_EVENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'wrench_mode/'
);

export interface WrenchHubUserAnalytic {
	supplierEmail: string;
	driveTimeMs: number;
	workTimeMs: number;
	totalTimeMs: number;
}

const fetchUtils = new FetchUtils();

export const fetchWrenchHubUserAnalyticsForSupplier = (
	fromDate: string,
	toDate: string,
	supervisorEmail?: string
): Promise<WrenchHubUserAnalytic[]> => {
	const supervisorQuery = supervisorEmail
		? `?supervisorEmail=${encodeURIComponent(supervisorEmail)}`
		: '';
	const queryUri = `${getBackendUri()}/api/v1/supplier/wrench_mode/events/analytics/${fromDate}/${toDate}${supervisorQuery}`;

	return fetchUtils
		.get(queryUri, {
			headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
		})
		.then(parseJSON)
		.then(({ json, ok }) => {
			const d = json;
			if (!ok || d.status === 'error') {
				throw new Error(d.message || 'Failed to fetch wrench hub user analytics');
			}
			return d.data || [];
		});
};
